import { j as o } from "./kezios-design-system.esm172.js";
import { Flex as c } from "@mantine/core";
import a from "./kezios-design-system.esm188.js";
import { Item as p } from "./kezios-design-system.esm189.js";
import { ChangingChevronAccordion as l } from "./kezios-design-system.esm113.js";
import { IconPlusCircle as f } from "./kezios-design-system.esm61.js";
import { IconMinusCircle as x } from "./kezios-design-system.esm59.js";
import { SectionLayout as u } from "./kezios-design-system.esm96.js";
import { Spacing as t } from "./kezios-design-system.esm135.js";
import { SectionHeader as j } from "./kezios-design-system.esm125.js";
const d = ({
  title: i,
  subtitle: m,
  category: n,
  children: r,
  sectionVariant: e = "left",
  ...s
}) => /* @__PURE__ */ o.jsx(u, { ...s, children: /* @__PURE__ */ o.jsxs(
  c,
  {
    className: a.flexContainer,
    px: t.s8,
    gap: t.s16,
    align: "start",
    direction: e === "center" ? "column" : "row",
    children: [
      /* @__PURE__ */ o.jsx(
        j,
        {
          category: n,
          title: i,
          subtitle: m,
          variant: e
        }
      ),
      /* @__PURE__ */ o.jsx(
        l,
        {
          variant: "faq",
          defaultValue: r[0].props.value,
          closedIcon: /* @__PURE__ */ o.jsx(f, { size: 24, color: "gray.4" }),
          openedIcon: /* @__PURE__ */ o.jsx(x, { size: 24, color: "gray.4" }),
          children: r
        }
      )
    ]
  }
) });
d.Item = p;
export {
  d as FaqSection
};
